<mat-checkbox (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()" class="mat-column-select">
</mat-checkbox>
<button mat-icon-button (click)="refresh()"><mat-icon>refresh</mat-icon></button>
